
import '../styles/index.scss';
import 'bootstrap';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import functions from './functions.js';

class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        window.jQuery = $;
        window.$ = $;

    }

    onDocumentLoad() {
        window.addEventListener("load", (event) => {             
            $(".toggle_menu").click(function(){
                $(this).toggleClass("active");
                $(".burger_menu_tabs").toggleClass("active");
            });

            $(".comment-reply-title").click(function(){
                $(".comments-area").toggleClass("active_comments");
            });

            $(window).scroll(function() {    
                var scroll = $(window).scrollTop();

                 //>=, not <=
                if (scroll >= 100) {
                    //clearHeader, not clearheader - caps H
                    $(".site_header").addClass("sticky_header");
                }
                else{
                    $(".site_header").removeClass("sticky_header");
                }
            }); 

            $(".footer_bottom .footer_menu_widget p.title").click(function(){  
                $(this).parent().find('ul').toggleClass("active");
                $(this).parent().siblings().find('ul').removeClass('active');
                //alert('11');
            }); 

        });
    }

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", (event) => {

 
        });
    }

    onResize() {
        window.addEventListener('resize', (event) => {
            this.headerHeight = this.header.height();
        });
    }


}

new Main();

$( function() {
   
  
} );
 


$(document).ready(function(){  
    $(".mobile_toggle").click(function(){  
        $(".site_header").toggleClass("mobile_header");  
    });
  
    $('#newstab').owlCarousel({
        loop:true,
        margin:20,
        nav:true,
        responsive:{
            0:{
                items:1
            },
            579:{
                items:2
            },
            767:{
                items:3
            },
            1024:{
                items:4
            },
            1200:{
                items:5
            }
        }
    });
    $('.accordion').on('click',function(){
        // $(this).next().slideToggle(800);
        $(this).toggleClass('active');
        $(this).next().toggleClass('show');
        $(this).find('.fa').toggleClass('chevron--rotate');
        
    });   

    // for travel showModalDialog js
     $(".bookNowbtn .btn").click(function(){
      $("html").addClass("overflow-hidden");
      $(".travelmodal").addClass("openModal");
     });
     $(".travelmodal .closeBtn").click(function(){
      $("html").removeClass("overflow-hidden");
      $(".travelmodal").removeClass("openModal");
     });



    $(document).ready(function() {
        var bigimage = $("#gallery_block_wrapper");
        var thumbs = $("#thumbs");
        //var totalslides = 10;
        var syncedSecondary = true;
      
        bigimage
          .owlCarousel({
          items: 1,
          slideSpeed: 2000,
          nav: true,
          autoplay: true,
          dots: false,
          loop: true,
          animateOut: 'fadeOut',
          animateIn: 'fadeIn',
          responsiveRefreshRate: 200,
          navText: [
            '<i class="fa fa-arrow-left" aria-hidden="true"></i>',
            '<i class="fa fa-arrow-right" aria-hidden="true"></i>'
          ]
        })
          .on("changed.owl.carousel", syncPosition);
      
        thumbs
          .on("initialized.owl.carousel", function() {
          thumbs
            .find(".owl-item")
            .eq(0)
            .addClass("current");
        })
          .owlCarousel({
          items: 4,
          dots: true,
          nav: true,
          navText: [
            '<i class="fa fa-arrow-left" aria-hidden="true"></i>',
            '<i class="fa fa-arrow-right" aria-hidden="true"></i>'
          ],
          smartSpeed: 200,
          slideSpeed: 500,
          slideBy: 4,
          responsiveRefreshRate: 100
        })
          .on("changed.owl.carousel", syncPosition2);
      
        function syncPosition(el) {
          //if loop is set to false, then you have to uncomment the next line
          //var current = el.item.index;
      
          //to disable loop, comment this block
          var count = el.item.count - 1;
          var current = Math.round(el.item.index - el.item.count / 2 - 0.5);
      
          if (current < 0) {
            current = count;
          }
          if (current > count) {
            current = 0;
          }
          //to this
          thumbs
            .find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
          var onscreen = thumbs.find(".owl-item.active").length - 1;
          var start = thumbs
          .find(".owl-item.active")
          .first()
          .index();
          var end = thumbs
          .find(".owl-item.active")
          .last()
          .index();
      
          if (current > end) {
            thumbs.data("owl.carousel").to(current, 100, true);
          }
          if (current < start) {
            thumbs.data("owl.carousel").to(current - onscreen, 100, true);
          }
        }
      
        function syncPosition2(el) {
          if (syncedSecondary) {
            var number = el.item.index;
            bigimage.data("owl.carousel").to(number, 100, true);
          }
        }
      
        thumbs.on("click", ".owl-item", function(e) {
          e.preventDefault();
          var number = $(this).index();
          bigimage.data("owl.carousel").to(number, 300, true);
        });
      });
      
    $('#storiestab').owlCarousel({
        loop:true,
        margin:20,
        nav:true,
        responsive:{
            0:{
                items:1
            },
            579:{
                items:2
            },
            767:{
                items:3
            },
            1024:{
                items:4
            },
            1200:{
                items:5
            }
        }
    });
    $('#topicstab').owlCarousel({
        loop:true,
        margin:20,
        nav:true,
        responsive:{
            0:{
                items:1
            },
            579:{
                items:2
            },
            767:{
                items:3
            },
            1024:{
                items:4
            },
            1200:{
                items:5
            }
        }
    });
      $('.destinationSlider').owlCarousel({
          loop:false,
          margin:22,
          nav:true,
          dots:false,
          responsive:{
              0:{
                  loop:true,
                  items:1
              },
              579:{
                  loop:true,
                  items:2
              },
              767:{
                  loop:true,
                  items:3
              },
              1350:{
                  loop:true,
                  items:3
              },
              1351:{
                  loop:false,
                  items:3
              }
          }
      });
/*for change tab*/
       $('.tabsBtn li a.btn').on('click', function(){
        var target = $(this).attr('data-rel');
        $('.tabsBtn li a.btn').removeClass('active');
          $(this).addClass('active');
          $("#"+target).fadeIn('slow').siblings(".tab-panel").hide();
          return false;
    });
});  

$(document).ready(function() {

    var sync1 = $("#sync1");
    var sync2 = $("#sync2");
    var slidesPerPage = 4; //globaly define number of elements per page
    var syncedSecondary = true;

    sync1.owlCarousel({
        items:1,
        slideSpeed:2000,
        nav:true,
        autoplay:false, 
        dots:false,
        loop:true,
        responsiveRefreshRate:200,
        navText: ['<svg width="100%" height="100%" viewBox="0 0 11 20"><path style="fill:none;stroke-width:2px;stroke: #fff;" d="M9.554,1.001l-8.607,8.607l8.607,8.606"/></svg>', '<svg width="100%" height="100%" viewBox="0 0 11 20" version="1.1"><path style="fill:none;stroke-width:2px;stroke: #fff;" d="M1.054,18.214l8.606,-8.606l-8.606,-8.607"/></svg>'],
    }).on('changed.owl.carousel', syncPosition);

    sync2
        .on('initialized.owl.carousel', function() {
            sync2.find(".owl-item").eq(0).addClass("current");
        })
        .owlCarousel({
            items:slidesPerPage,
            dots:false,
            nav:false,
            margin:20,
            smartSpeed:200,
            slideSpeed:500,
            slideBy:slidesPerPage, //alternatively you can slide by 1, this way the active slide will stick to the first item in the second carousel
            responsiveRefreshRate:100
        }).on('changed.owl.carousel', syncPosition2);

    function syncPosition(el) {
        //if you set loop to false, you have to restore this next line
        //var current = el.item.index;

        //if you disable loop you have to comment this block
        var count = el.item.count - 1;
        var current = Math.round(el.item.index - (el.item.count / 2) - .5);

        if (current < 0) {
            current = count;
        }
        if (current > count) {
            current = 0;
        }

        //end block

        sync2
            .find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
        var onscreen = sync2.find('.owl-item.active').length - 1;
        var start = sync2.find('.owl-item.active').first().index();
        var end = sync2.find('.owl-item.active').last().index();

        if (current > end) {
            sync2.data('owl.carousel').to(current, 100, true);
        }
        if (current < start) {
            sync2.data('owl.carousel').to(current - onscreen, 100, true);
        }
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            sync1.data('owl.carousel').to(number, 100, true);
        }
    }

    sync2.on("click", ".owl-item", function(e) {
        e.preventDefault();
        var number = $(this).index();
        sync1.data('owl.carousel').to(number, 300, true);
    });
});


// WEBPACK FOOTER //
// ./src/scripts/index.js